import type { ReactNode } from 'react'

import s from './Section.module.css'

/** Centered empty / error state (prototype `.empty`). Actions go in `children`. */
export function EmptyState({
  icon,
  title,
  text,
  children,
  headingLevel = 2,
}: {
  icon: ReactNode
  title: ReactNode
  text?: ReactNode
  children?: ReactNode
  headingLevel?: 1 | 2
}) {
  const H = headingLevel === 1 ? 'h1' : 'h2'
  return (
    <div className={s.empty}>
      <span className={s.emptyIc} aria-hidden="true">
        {icon}
      </span>
      <H>{title}</H>
      {text && <p>{text}</p>}
      {children}
    </div>
  )
}
